import ExpandableSection from './ExpandableSection';

export default ExpandableSection;
